export default function ProductCardHorizontal() {
  return <div>ProductCardHorizontal</div>;
}
